/** Filter state for the Journal view (#12358). */
export interface JournalFilters {
  search: string
  statuses: string[]
  onlyKvar: boolean
  fromDate: string
  toDate: string
  minBelopp: string
  maxBelopp: string
}

export const EMPTY_JOURNAL_FILTERS: JournalFilters = {
  search: '', statuses: [], onlyKvar: false,
  fromDate: '', toDate: '', minBelopp: '', maxBelopp: '',
}
